import Dashboard from "../pages/Dashboard";
import Login from "../auth/signin/Login";
// import Signup from "../auth/signup/Signup";
import { FaUser, FaCar, FaUsers } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { LuSettings2 } from "react-icons/lu";
import { MdCommute } from "react-icons/md";
import { Navigate } from "react-router-dom";
import Drivers from "../pages/Drivers";
import Rides from "../pages/Rides";
import Vehicles from "../pages/Vehicles";
import Configuration from "../pages/Configuration";
import Providers from "../pages/configuration/Providers";
import ServerURLs from "../pages/configuration/ServerURLs";
import User from "../pages/User";
import Unauthorized from "../components/common/Unauthorized";

export const routes = [
  {
    path: "/credentials",
    element: <Dashboard />,
    name: "Credentials",
    icon: RiLockPasswordFill,
    layout: "app",
    roles: [0, 1],
  },
  {
    path: "/login",
    element: <Login />,
    name: "Login",
    layout: "auth",
  },
  // {
    //   path: "/signup",
    //   element: <Signup />,
    //   name: "Signup",
    //   layout: "auth",
    // },
    {
      path: "/drivers",
      element: <Drivers />,
      name: "Drivers",
      layout: "app",
      icon: FaUser,
      roles: [1],
    },
    {
      path: "/vehicles",
      element: <Vehicles />,
      name: "Vehicles",
      layout: "app",
      icon: FaCar,
      roles: [1],
    },
    {
      path: "/rides",
      element: <Rides />,
      name: "Rides",
      layout: "app",
      icon: MdCommute,
      roles: [1],
    },
    {
      path: "/configuration",
      element: <Configuration />,
      name: "Configuration",
      layout: "app",
      icon: LuSettings2,
      roles: [1],
      children: [
        {
          path: "",
          element: <Navigate to="providers" replace />,
        },
        {
          path: "providers",
          element: <Providers />,
          name: "Providers",
        },
        {
          path: "server-urls",
          element: <ServerURLs />,
          name: "Server Urls",
        },
      ],
    },
    {
      path: "/users",
      element: <User />,
      name: "Users",
      layout: "app",
      icon: FaUsers,
      roles: [1],
    },
    {
      path: "/403",
      element: <Unauthorized />,
      name: "Unauthorized",
      layout: "app",
    },
];

export default routes;
